import React from 'react';
import { Loader, Table } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import TableHeader from '@/components/table/TableHeader';
import DatasetAttachmentsTableTitle from './DatasetAttachmentsTableTitle';
import DatasetAttachmentsFilters from './DatasetAttachmentsFilters';
import DatasetAttachmentsTableDragDrop from './DatasetAttachmentsTableDragDrop';
import DatasetAttachmentsTableColumns from './DatasetAttachmentsTableColumns';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import FolderControls from './FolderControls';

const DatasetAttachmentsTableHeader = ({
  category,
  code,
  columns,
  items,
  uppy,
}) => {
  const {
    canUpload, canUpdate, orderBy, readStatus, storageEnabled,
  } = Selectors.useDatasetAttachmentsTableHeader({ category, code });
  const onOrderByColumn = Events.useToggleDatasetAttachmentColumnOrderBy(category, { code });

  return (
    <Table.Header fullWidth>
      <TableHeader
        className="aridhia-dataset-attachments-table-header"
        numberOfColumns={columns.length}
      >
        <DatasetAttachmentsTableTitle category={category} code={code} withDescription={canUpload || canUpdate} />
        {readStatus === states.PENDING && <Loader active inline size="tiny" className="ml-10" />}
        <div className="flex-1" />
        <FolderControls category={category} code={code} />
        <DatasetAttachmentsFilters category={category} code={code} />
      </TableHeader>
      {canUpload && storageEnabled && (
        <DatasetAttachmentsTableDragDrop canUpload colSpan={columns.length} uppy={uppy} />
      )}
      {items.length > 0 && (
        <DatasetAttachmentsTableColumns
          columns={columns}
          items={items}
          onOrderByColumn={onOrderByColumn}
          orderBy={orderBy}
        />
      )}
    </Table.Header>
  );
};

export default DatasetAttachmentsTableHeader;
